var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock24H = function SvgClock24H(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock-24h_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".clock-24h_svg__st0{fill:#424242}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clock-24h_svg__st0",
    d: "M22.7 44.5c-11.1 0-20.2-9.2-20.2-20.3S11.5 4 22.8 4c11.1 0 20.3 9.1 20.3 20.2 0 .7 0 1.4-.1 2.1 0 .5-.5.8-.9.8s-.8-.5-.8-.9c.1-.7.1-1.2.1-1.9 0-10.3-8.3-18.6-18.6-18.6S4.2 14 4.2 24.3s8.3 18.6 18.6 18.6c.5 0 .8.4.8.8-.1.4-.4.8-.9.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "clock-24h_svg__st0",
    d: "M15.4 25.1c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h6.5V13.2c0-.5.4-.8.8-.8.5 0 .8.4.8.8v11c0 .5-.4.8-.8.8h-7.3v.1zM42.1 28.3c-.3 0-.6-.2-.8-.4l-3.1-5.4c-.2-.4-.1-.9.3-1.1.4-.2.9-.1 1.1.3l2.4 4.2 2.4-4.2c.2-.4.8-.6 1.1-.3.4.2.6.8.3 1.1l-3.1 5.4c0 .2-.3.4-.6.4zM33.8 32.9H29c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8h4.8c.5 0 .8.4.8.8.1.4-.3.8-.8.8zM33.8 42.6H29c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8h4.8c.5 0 .8.4.8.8.1.4-.3.8-.8.8zM33.8 37.8H29c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h4.8c.5 0 .8.4.8.8s-.3.8-.8.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "clock-24h_svg__st0",
    d: "M29 42.6c-.5 0-.8-.4-.8-.8V37c0-.5.4-.8.8-.8.5 0 .8.4.8.8v4.8c.1.4-.3.8-.8.8zM42.5 42.6c-.5 0-.8-.4-.8-.8V37c0-.5.4-.8.8-.8.5 0 .8.4.8.8v4.8c.1.4-.3.8-.8.8zM33.8 37.8c-.5 0-.8-.4-.8-.8v-4.8c0-.5.4-.8.8-.8s.8.4.8.8V37c.1.4-.3.8-.8.8zM37.7 37.8c-.5 0-.8-.4-.8-.8v-4.8c0-.5.4-.8.8-.8.5 0 .8.4.8.8V37c0 .4-.3.8-.8.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "clock-24h_svg__st0",
    d: "M42.5 37.8c-.5 0-.8-.4-.8-.8v-4.8c0-.5.4-.8.8-.8.5 0 .8.4.8.8V37c.1.4-.3.8-.8.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "clock-24h_svg__st0",
    d: "M42.5 37.8h-4.8c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h4.8c.5 0 .8.4.8.8s-.3.8-.8.8z"
  })));
};
export default SvgClock24H;